import { H6, H2, H3, P, UL } from '../../AbstractElements';
import { Subscribe, month } from '../../Constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { postMasterToken } from '../../Utils/restUtils';
import { storeMultiComp } from '../../CommonUrl';
import { useNavigate } from 'react-router';
import HandleHomePageError from '../../Components/Common/ErrorImport/SignError';
import Transparentspinner from '../../Components/Common/Loader/Transparentspinner';

const SubCard = (props) => {
    const priceDetails = props.details;
    const authState = props.auth;
    const navigate = useNavigate();
    const [loading, setloading] = useState(false);

    const containerRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const checkOverflow = () => {
        if (containerRef.current) {
            const { scrollWidth, clientWidth } = containerRef.current;
            setIsOverflow(scrollWidth > clientWidth);
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const resizeObserver = new ResizeObserver(() => {
            checkOverflow();
        });
        resizeObserver.observe(container);
        checkOverflow();

        return () => {
            resizeObserver.disconnect();
        };
    }, [priceDetails?.packages]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container || !isOverflow) return;

        let intervalId;
        let direction = 1; // 1 = scroll right, -1 = scroll left

        const startScrolling = () => {
            intervalId = setInterval(() => {
                if (isHovered) return;

                const maxScroll = container.scrollWidth - container.clientWidth;
                if (maxScroll <= 0) return;

                const currentScroll = container.scrollLeft;

                if (currentScroll >= maxScroll - 1 && direction === 1) {
                    direction = -1;
                } else if (currentScroll <= 0 && direction === -1) {
                    direction = 1;
                }

                container.scrollLeft += direction;
            }, 35);
        };

        startScrolling();

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isOverflow, isHovered]);

    const scroll = (dir) => {
        if (containerRef.current) {
            const scrollAmount = 380;
            containerRef.current.scrollBy({
                left: dir === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const submitSubscription = async (item) => {
        setloading(true);
        const postRequest = { package_id: item.id, industry_type_id: authState.industryId, company_id: props.companyId, company: 'multi_company' }
        const response = await postMasterToken(storeMultiComp, postRequest);
        if (response.status === 200) {
            navigate('/dashboard/company-list');
        } else {
            HandleHomePageError(navigate, response.status)
        }
        setloading(false);
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <CardBody className='pt-2'>
                <div 
                    className="pricing-carousel-wrapper"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {isOverflow && (
                        <button 
                            type="button" 
                            className="pricing-carousel-btn prev" 
                            onClick={() => scroll('left')}
                            aria-label="Previous"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                    )}

                    <div 
                        className="pricing-carousel-container" 
                        ref={containerRef}
                    >
                        <Row className={`pricing-content pricing-col flex-nowrap m-0 ${isOverflow ? '' : 'justify-content-center'}`}>
                            {
                                priceDetails?.packages
                                    .filter((item) => Number(item.price) !== 0)
                                    .map((item, index) => {
                                        const integerNumber = Number(item.price);
                                        return (
                                            <Col md='4' className='mt-4' key={index}>
                                                <Card className={`pricing-new-card`}>
                                                    {/* {isPopular && (
                                                                                    <div className="most-popular-ribbon">
                                                                                        <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                                                                                        MOST POPULAR
                                                                                    </div>
                                                                                )} */}
                                                    <div className="pricing-header">
                                                        <H2>{item.name}</H2>
                                                        <div className="subtitle">{item.description}</div>
                                                        <div className="price-display">
                                                            {/* {integerNumber !== 0 && <span className="original-price">{authState.currency}{item.price}</span>} */}
                                                            <H3>{item.currency ? item.currency : '$'}{item.min_price}</H3>
                                                            <span className="duration">/{item.duration}</span>
                                                        </div>
                                                        {integerNumber !== 0 && (
                                                            <div className="setup-cost">
                                                                Setup Cost <span className="setup-cost-amount">{item.currency ? item.currency : '$'} {item.setup_cost}</span>
                                                            </div>
                                                        )}
                                                        {integerNumber === 0 && <div className="setup-cost">No credit card required</div>}
                                                    </div>

                                                    <div className="connection-box">
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                                        <span>{integerNumber === 0 ? `Max connections ${item.max_connection}` : `Up to ${item.min_connection} connections - ${item.currency ? item.currency : '$' }${item.price}/extra`}</span>
                                                    </div>

                                                    <div className="whats-included">WHAT'S INCLUDED</div>

                                                    <ul className="pricing-features">
                                                        {item.features && item.features.split('\n').map((feature, fIndex) => {
                                                            if (!feature.trim()) return null;
                                                            return (
                                                                <li key={`feature-${fIndex}`}>
                                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                    <span>{feature}</span>
                                                                </li>
                                                            );
                                                        })}
                                                        <li>
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                            <span>Duration: {item.duration}</span>
                                                        </li>
                                                        {/* <li>
                                                                                        {item.sms === 'off' ? 
                                                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                                                            : 
                                                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                                        }
                                                                                        <span style={{textDecoration: item.sms === 'off' ? 'line-through' : 'none', color: item.sms === 'off' ? '#94a3b8' : 'inherit'}}>SMS Notifications</span>
                                                                                    </li> */}
                                                    </ul>

                                                    <div  className="pricing-footer">
                                                        <button className="btn-pricing" onClick={() => submitSubscription(item)}>{Subscribe}</button>
                                                    </div>
                                                </Card>
                                            </Col>
                                        )
                                    })
                            }
                        </Row>
                    </div>

                    {isOverflow && (
                        <button 
                            type="button" 
                            className="pricing-carousel-btn next" 
                            onClick={() => scroll('right')}
                            aria-label="Next"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    )}
                </div>
            </CardBody>
        </Fragment>
    );
};

export default SubCard;
